import {
	Activator,
	Submitter,
	Datepicker,
	Sortable,
	Spectrum,
	resizableEditorComponent,
	InfoBar,
	InputChangeHandler,
} from 'component'
import * as M from 'materialize-css'
import Alpine from 'alpinejs'
import Modal from './modal'
import Select from './select'
import Collapsible from './collapsible'
import AlpineNetteRequestsPlugin from '../alpine/alpineNetteRequestsPlugin'

type Props = {
	isAjax: boolean
}

const Global = (() => {
	const init = (props: Props) => {
		const modal = Modal()
		const select = Select()
		const collapsible = Collapsible()

		Activator.init()
		Submitter.init()
		Datepicker.init({ isAjax: props.isAjax })
		Sortable.init()
		Spectrum.init()
		InfoBar.init()
		InputChangeHandler.init()
		modal.init()
		select.init()
		collapsible.init()
		resizableEditorComponent.init()
		const elements = document.querySelectorAll('input[type=range]')
		M.Range.init(elements)
		if (!props.isAjax) {
			// without this condition, details in action planner are displayed multiple times
			Alpine.plugin(AlpineNetteRequestsPlugin)
			Alpine.start()
		}
	}

	return {
		init,
	}
})()

export default Global
